<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i>Catalogs
            </div>
            <div class="card-block">
              <table class="table table-bordered table-striped table-condensed">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>DevOps Version</th>
                    <th>Trials</th>
                    <th>Promotion Window Size</th>
                    <th>Created at</th>
                  </tr>
                </thead>
                <tbody>
                  <loading-rows v-if="loading" cols='5'/>
                  <tr v-for="catalog in catalogs" v-if="!loading">
                    <td>{{catalog.id}}</td>
                    <td><router-link :to="{ name: 'Catalog', params: {id: catalog.id} }">{{catalog.name}}</router-link></td>
                    <td><router-link :to="{ name: 'CatalogDevops', params: {id: catalog.id} }" class="btn btn-primary">{{catalog.name}}</router-link></td>
                    <td>{{catalog.trials}}</td>
                    <td>{{catalog.promotion_window_size}}</td>
                    <td>{{catalog.created_at | moment('LL')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>

import catalogs from 'services/catalogs'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'catalogs',
  created () {
    this.fetchData()
  },
  data () {
    return {
      catalogs: [],
      loading: false
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    LoadingRows
  },
  methods: {
    fetchData () {
      catalogs.all(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/catalogs/Catalogs.vue